import { render } from "./license.windows.vue?vue&type=template&id=e73ab766&scoped=true"
import script from "./license.windows.vue?vue&type=script&lang=js"
export * from "./license.windows.vue?vue&type=script&lang=js"

import "./license.windows.vue?vue&type=style&index=0&id=e73ab766&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e73ab766"]])

export default __exports__